import { notEmpty } from '../../../ui-toolkit/utilities/notEmpty';
import { DateTime } from 'luxon';
import { UUID } from '../../shared/UUID';
import { IOrderTaskData } from './IOrderTaskData';

export interface IUpdateOrderTaskRequest {
  id: UUID;
  role?: string;
  teammateId?: UUID | null;
  completed?: boolean;
  delete?: boolean;
  dueDate?: string | null;
  priorityScore?: number;
}

export interface IUpdateCompletedOrderTaskRequest {
  id: UUID;
  completedBy?: UUID | null;
  completedAt?: string | null;
}

export const convertIOrderTaskDataToIUpdateOrderTaskRequest = (orderTask: IOrderTaskData): IUpdateOrderTaskRequest => {
  const { id, teammate, completed, dueDate } = orderTask;
  if (notEmpty(id) && completed !== undefined) {
    return {
      id,
      completed,
      teammateId: teammate ? teammate.id : undefined,
      dueDate: dueDate ? DateTime.fromISO(dueDate).toISODate() : undefined,
    };
  }
  throw new Error('Cannot convert IOrderTaskData to IUpdateOrderTaskRequest');
};
